/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Fact_Usable_AreaInputs */

const cs_public_site_fact_usable_area = /** @type {(inputs: Public_Site_Fact_Usable_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Užitná plocha`)
};

const en_public_site_fact_usable_area = /** @type {(inputs: Public_Site_Fact_Usable_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usable area`)
};

/**
* | output |
* | --- |
* | "Usable area" |
*
* @param {Public_Site_Fact_Usable_AreaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_fact_usable_area = /** @type {((inputs?: Public_Site_Fact_Usable_AreaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Fact_Usable_AreaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_fact_usable_area(inputs)
	return cs_public_site_fact_usable_area(inputs)
});